/* Dog breed -> size selector (works for ES / PT / EN / any option name) */
(function () {
  if (window.dogBreedSelectorInitialized) return;
  window.dogBreedSelectorInitialized = true;

  /* ---------- helpers ---------- */
  function normalize(str) {
    return (str || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function getLang(container) {
    if (container && container.dataset && container.dataset.lang) {
      return container.dataset.lang.toLowerCase().slice(0, 2);
    }
    var suffix = (window.currentTemplateSuffix || '').toLowerCase();
    if (/(^|[-_])pt$/.test(suffix)) return 'pt';
    var htmlLang = (document.documentElement.lang || 'es').toLowerCase().slice(0, 2);
    return htmlLang === 'pt' ? 'pt' : 'es';
  }

  var TEXT = {
    es: {
      rec: function (b) { return 'Para ti ' + b + ', Nosotras recomendamos:'; },
      none: function (b) { return 'Para ti ' + b + ', ¡No se encontraron resultados coincidentes!'; }
    },
    pt: {
      rec: function (b) { return 'Para o teu ' + b + ', recomendamos:'; },
      none: function (b) { return 'Para o teu ' + b + ', não foram encontrados resultados correspondentes!'; }
    }
  };

  /* "XS - 40cm" / "XS – 40cm" / "XS_40cm" -> "xs" */
  function sizeToken(value) {
    return normalize((value || '').split(/-|–|_/)[0]);
  }

  /* ---------- search ---------- */
  window.searchresultbreed = function (input) {
    var term = normalize(input.value);
    var dropdown = input.closest('.suggestion-container').querySelector('.dropdown-content');
    dropdown.querySelectorAll('.option-list').forEach(function (breed) {
      breed.style.display = normalize(breed.textContent).includes(term) ? 'block' : 'none';
    });
  };

  /* ---------- find the variant picker for this container ---------- */
  function findVariantSelector(container) {
    var vs = null;
    var popup = container.closest('.size-guide-popup');
    if (popup) {
      var sectionId = popup.id.replace('sizeGuidePopup-', '');
      vs = document.getElementById('variant-selects-' + sectionId) ||
           document.querySelector('variant-selects[data-section="' + sectionId + '"]');
    }
    if (!vs) {
      var scope = container.closest('section, .product, .product__info, .product-form');
      vs = (scope && scope.querySelector('.mff_variant-selects')) ||
           document.querySelector('.mff_variant-selects') ||
           document.querySelector('variant-selects');
    }
    return vs;
  }

  /* ---------- apply the size (option-name independent) ---------- */
  function applySize(variantSelector, size) {
    var wanted = normalize(size);

    // 1) radios (pill / swatch layout) - Tamanho, Tamaño, Size, Talla...
    var radios = Array.prototype.slice.call(
      variantSelector.querySelectorAll('input[type="radio"]')
    ).filter(function (r) { return sizeToken(r.value) === wanted; });

    if (radios.length) {
      var radio = radios.find(function (r) { return !r.disabled; }) || radios[0];
      if (!radio.checked) {
        radio.click(); // sets checked + fires input/change like a real click
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        }
      }
      return true;
    }

    // 2) dropdown layout
    var selects = variantSelector.querySelectorAll('select:not([disabled])');
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      var opt = Array.prototype.find.call(sel.options, function (o) {
        return sizeToken(o.value) === wanted;
      });
      if (opt) {
        sel.value = opt.value;
        sel.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
        return true;
      }
    }
    return false;
  }

  /* ---------- events (delegated, survive re-renders) ---------- */
  document.addEventListener('click', function (event) {
    var target = event.target;

    // toggle dropdown
    var toggle = target.closest('.suggestion-container .toggle-dropdown-btn');
    if (toggle) {
      var c = toggle.closest('.suggestion-container');
      var content = c.querySelector('.dropdown-content');
      content.classList.toggle('hide');
      if (!content.classList.contains('hide')) {
        var input = c.querySelector('.search-results-input');
        if (input) input.focus();
      }
      return;
    }

    // choose breed
    var option = target.closest('.suggestion-container .option-list');
    if (option) {
      var container = option.closest('.suggestion-container');
      var breed = option.textContent.trim();
      var size = option.getAttribute('data-value');
      var text = TEXT[getLang(container)] || TEXT.es;

      container.querySelector('.dropdown-content').classList.add('hide');
      container.querySelector('.btn-changeable-text').textContent = breed;

      var rec = container.querySelector('.recommendation-section');
      var phrase = rec && rec.querySelector('.selected-value-title-phrase');
      var value = rec && rec.querySelector('.selected-value');
      if (rec) rec.classList.remove('hide');

      var vs = findVariantSelector(container);
      var ok = vs ? applySize(vs, size) : false;

      if (rec) {
        if (ok || !vs) {
          phrase.textContent = text.rec(breed);
          value.textContent = size;
        } else {
          phrase.textContent = text.none(breed);
          value.textContent = '';
        }
      }
      return;
    }

    // click elsewhere: close open dropdowns
    document.querySelectorAll('.suggestion-container .dropdown-content').forEach(function (dd) {
      if (!dd.closest('.suggestion-container').contains(target)) dd.classList.add('hide');
    });
  });
})();